module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1194.09b2ad90.png";